import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/director/school",
  },
  actions: {
    // Dars jadvali tahrirlash holatini boshqarish
    "toggle-lesson-schedule-edit"({ dispatch, state, rootState }, data) {
      const { tu, cu, cn, l, ...body } = data || {};
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/toggle-lesson-schedule-edit?${serialize({ tu, cu, cn, l })}`,
          method: "POST",
          data: body,
        },
        { root: true }
      );
    },
    "get-lesson-schedule-edit-status"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-edit-status?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // Baz cheklovlarini boshqarish
    "get-database-restrictions"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/database-restrictions?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "set-database-restriction"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/database-restriction`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    "remove-database-restriction"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/database-restriction`,
          method: "DELETE",
          data,
        },
        { root: true }
      );
    },
    // Ta'lim narxlari boshqaruvi
    "get-education-prices"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/education-prices?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "add-education-price"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/education-price`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    "update-education-price"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/education-price`,
          method: "PUT",
          data,
        },
        { root: true }
      );
    },
    "delete-education-price"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/education-price`,
          method: "DELETE",
          data,
        },
        { root: true }
      );
    },
    // Maktab statistikasi
    "get-school-statistics"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/statistics?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // Filiallar ro'yxati
    "get-branches"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/branches?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // Dars jadvalini bir kunga ochish — bir martalik istisno kunlari
    "get-lesson-schedule-open-days"({ dispatch, state }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-open-days?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "add-lesson-schedule-open-day"({ dispatch, state }, data) {
      const { tu, cu, cn, l, ...body } = data || {};
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-open-day?${serialize({ tu, cu, cn, l })}`,
          method: "POST",
          data: body,
        },
        { root: true }
      );
    },
    "update-lesson-schedule-open-day"({ dispatch, state }, data) {
      const { tu, cu, cn, l, ...body } = data || {};
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-open-day?${serialize({ tu, cu, cn, l })}`,
          method: "PUT",
          data: body,
        },
        { root: true }
      );
    },
    "delete-lesson-schedule-open-day"({ dispatch, state }, data) {
      const { tu, cu, cn, l, ...body } = data || {};
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-open-day?${serialize({ tu, cu, cn, l })}`,
          method: "DELETE",
          data: body,
        },
        { root: true }
      );
    },
    "get-lesson-schedule-can-edit"({ dispatch, state }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lesson-schedule-can-edit?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};

